import { useState } from 'react';

import { AxiosPrivate } from '../utils/axios';
import { ResponseException } from '../models';

export const useUploadExcelFile = () => {
  const [isUploading, setUploading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const uploadFile = async (endpoint: string, files: File[], image?: boolean) => {
    try {
      if (!files?.length) {
        setErrors(['You must select a file']);
        return;
      }

      setUploading(true);
      setErrors([]);
      const formData = new FormData();
      formData.append('file', files[0]);
      if (image) formData.append('name', files[0].name);
      const res = await AxiosPrivate.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res;
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setUploading(false);
    }
  };

  const uploadComments = async (files: File[]) => {
    return await uploadFile('/comments/import', files);
  };

  const uploadResponses = async (files: File[]) => {
    return await uploadFile('/responses/import', files);
  };

  return {
    isUploading,
    errors,
    uploadComments,
    uploadResponses,
    uploadFile,
  };
};
